<template>
    <div v-if="featureInfo" class="v-atlas-raumplanung-feature-info-overview">

        <template v-if="props.featureInfo.entity_compareGroup">
            <strong>{{ props.featureInfo.entity_compareGroup.name?.[0].value }}</strong>
        </template>

        <h3>
            {{ featureInfo.attrMetadata.attrLabel }}, {{ featureInfo.attrMetadata.timeFrameLabel }}
        </h3>

        <div class="v-atlas-raumplanung-feature-info__mainValue">

            <div>
                {{ formatNumber(featureInfo.currentValue, {
                    numDecimals: featureInfo.attrMetadata.numDecimals ?? 2
                }) }} {{ featureInfo.attrMetadata.unit }}
            </div>

            <div v-if="featureInfo.entity_compareGroup">

            </div>
        </div>



        <!--#region The main indicator chart -->




        <template v-if="option">
            <h3>{{ featureInfo.attrMetadata.attrLabel }}, Historische Entwicklung</h3>
            <VChart class="chart" :option="option as ECBasicOption" autoresize @click="handleChartClick" />
        </template>
        <template v-else>
            Hinweis: Für Zeitraum-basierte Indikatoren ist keine Visualisierung der historischen Entwicklung verfügbar.
        </template>
        <!--#endregion The main indicator chart -->

        <!--
        <div v-if="props.featureInfo.entity_compareGroup">
            <h3>Vergleichsgruppe</h3>

            <strong>{{ props.featureInfo.entity_compareGroup.name?.[0].value }}</strong>
        </div>
        -->

        <!--#region Raumplanerische Funktionszuweisungen-->

        <div v-if="featureInfo?.entity?._tags.includes('type:Gemeinde')"
            class="v-atlas-raumplanung-feature-info__funktionszuweisungen">
            <h3>Raumplanerische Funktionszuweisungen</h3>
            <h4>Raumkategorie:</h4>
            {{ featureInfo?.entity?.raumkategorie?.[0]?.value }}

            <h4>Zentralörtlichkeit:</h4>
            {{ featureInfo?.entity?.zentraloertlichkeit?.[0]?.value }}
            <h4>Wohnfunktion:</h4>
            {{ featureInfo?.entity?.wohnfunktion?.[0]?.value }}
            <h4>Gewerbefunktion:</h4>
            {{ featureInfo?.entity?.gewerbefunktion?.[0]?.value }}
        </div>

        <!--#endregion Raumplanerische Funktionszuweisungen-->
    </div>



</template>

<script setup lang="ts">

import { RaumplanungFeatureInfoResponse } from "atlas-shared";
import { formatNumber } from "gertrud";

import VChart from 'vue-echarts';

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
} from 'echarts/components';

import { LineChart } from 'echarts/charts';

import { computed } from "vue";
import { ECBasicOption } from "echarts/types/dist/shared";
import { RaumplanungMapModule } from "./RaumplanungMapModule";


const props = defineProps<{
    featureInfo: RaumplanungFeatureInfoResponse
    mapModule: RaumplanungMapModule
}>()


use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    LineChart,
]);



const option = computed(() => {
    return props.featureInfo.eChartsOption
})

function handleChartClick(params: any) {

    if (params.value) {
        props.mapModule.requestSettings.year = parseInt(params.value)

    }
}

</script>

<style scoped>
.chart {
    width: 100%;
    height: 350px;

}
</style>